import { render, staticRenderFns } from "./UserSettingsModal.vue?vue&type=template&id=aa7791ae&scoped=true&"
import script from "./UserSettingsModal.vue?vue&type=script&lang=js&"
export * from "./UserSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7791ae",
  null
  
)

export default component.exports